export const CENGAGE_VERIFICATION_START = 'CENGAGE_VERIFICATION_START';
export const CENGAGE_VERIFICATION_START_MESSAGE =
  "Your security is our priority, which is why we've started manual verification at Cengage of your identity at your institution.";

export const SHEERID_DOCUPLOAD_STARTED = 'SHEERID_MANUAL_STARTED';
export const SHEERID_DOCUPLOAD_STARTED_MESSAGE =
  'We will need more information from you to complete verification. ';
export const SHEERID_DOCUPLOAD_LINK_MESSAGE =
  'Click here to provide additional information.';
export const SHEERID_AUTOMATIC_SUCCESS = 'SHEERID_AUTOMATIC_SUCCESS';
export const SHEERID_AUTOMATIC_SUCCESS_MESSAGE =
  'Your identity has been verified.';